<template>
  <wrld-container :breadcrumbs="this.breadcrumbs">
    <wrld-box
      :headerTitle="$t('fleet.my_internal_fleet')"
    >
      <template v-slot:headerBtns>
        <v-btn
          outlined
          :loading="vehicles.isFetching"
          @click="fetchVehicles()"
          class="mr-4 mb-3 px-8"
        >
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" class="text-center">
          <template v-slot:activator="{ on }">
            <v-btn
              class="mr-4 mb-3"
              color="accent"
              v-on="on"
            >{{ $t('fleet.import') }}</v-btn>
          </template>
          <v-card>
            <v-card-title class="title justify-center">
              {{ $t('fleet.import_internal_fleet') }}
            </v-card-title>
            <v-spacer></v-spacer>
            <v-card-actions class="justify-center">
              <v-btn @click="dialog = false" color="accent" class="white--text">{{$t('fleet.close')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn
          color="accent"
          @click="gotoCreateVehicle()"
          class="mb-3"
        >{{$t('fleet.create_new_btn')}}</v-btn>
      </template>
      <template v-slot:boxContent>
        <VehicleListTable :fleet="internalFleet" :isFetching="vehicles.isFetching" @go-to-detail="gotoDetail"/>
      </template>
    </wrld-box>
  </wrld-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import router from '@/router'
import VehicleListTable from '@/components/fleet/VehicleListTable.vue'

export default {
  name: 'InternalFleet',
  components: {
    VehicleListTable
  },
  data () {
    return {
      breadcrumbs: [
        { text: 'Wereldo', disabled: false, href: '#/' },
        { text: this.$i18n.t('fleet.internal_fleet'), disabled: true }
      ],
      dialog: false
    }
  },
  computed: {
    ...mapState(['route', 'vehicles']),
    ...mapGetters({
      internalFleet: 'internalFleet'
    })
  },
  created () {
    this.fetchVehicles()
  },
  methods: {
    ...mapActions({
      fetchVehicles: 'fetchVehicles'
    }),
    gotoDetail (vehicleID) {
      router.push({ name: 'VehicleDetail', params: { vehicleID: vehicleID } })
    },
    gotoCreateVehicle () {
      router.push({ name: 'CreateVehicle' })
    }
  }
}
</script>

<style lang="scss">
.v-btn {
  letter-spacing: 0;
}
</style>
